/**
 * @generated SignedSource<<f9081250c6dcd45b5f81539280155ca3>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueFieldPills$data = {
  readonly issueFieldValues?: {
    readonly nodes: ReadonlyArray<{
      readonly __typename: "IssueFieldDateValue";
      readonly field: {
        readonly name?: string;
      } | null | undefined;
      readonly value: string;
    } | {
      readonly __typename: "IssueFieldMultiSelectValue";
      readonly field: {
        readonly name?: string;
      } | null | undefined;
      readonly options: ReadonlyArray<{
        readonly name: string;
      }>;
    } | {
      readonly __typename: "IssueFieldNumberValue";
      readonly field: {
        readonly name?: string;
      } | null | undefined;
      readonly numberValue: number;
    } | {
      readonly __typename: "IssueFieldSingleSelectValue";
      readonly field: {
        readonly name?: string;
      } | null | undefined;
      readonly value: string;
    } | {
      readonly __typename: "IssueFieldTextValue";
      readonly field: {
        readonly name?: string;
      } | null | undefined;
      readonly value: string;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "IssueFieldPills";
};
export type IssueFieldPills$key = {
  readonly " $data"?: IssueFieldPills$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueFieldPills">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "showIssueFieldPills"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "IssueFieldPills",
  "selections": [
    {
      "condition": "showIssueFieldPills",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 25
            }
          ],
          "concreteType": "IssueFieldValueConnection",
          "kind": "LinkedField",
          "name": "issueFieldValues",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v0/*:: as any*/),
                    (v1/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "field",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "InlineFragment",
                          "selections": (v2/*:: as any*/),
                          "type": "IssueFieldText",
                          "abstractKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "IssueFieldTextValue",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v0/*:: as any*/),
                    (v1/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "field",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "InlineFragment",
                          "selections": (v2/*:: as any*/),
                          "type": "IssueFieldSingleSelect",
                          "abstractKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "IssueFieldSingleSelectValue",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v0/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "IssueFieldSingleSelectOption",
                      "kind": "LinkedField",
                      "name": "options",
                      "plural": true,
                      "selections": (v2/*:: as any*/),
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "field",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "InlineFragment",
                          "selections": (v2/*:: as any*/),
                          "type": "IssueFieldMultiSelect",
                          "abstractKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "IssueFieldMultiSelectValue",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v0/*:: as any*/),
                    (v1/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "field",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "InlineFragment",
                          "selections": (v2/*:: as any*/),
                          "type": "IssueFieldDate",
                          "abstractKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "IssueFieldDateValue",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v0/*:: as any*/),
                    {
                      "alias": "numberValue",
                      "args": null,
                      "kind": "ScalarField",
                      "name": "value",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "field",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "InlineFragment",
                          "selections": (v2/*:: as any*/),
                          "type": "IssueFieldNumber",
                          "abstractKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "IssueFieldNumberValue",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "issueFieldValues(first:25)"
        }
      ]
    }
  ],
  "type": "Issue",
  "abstractKey": null
};
})();

(node as any).hash = "6f626938dd872730d0d7b99bad42fbf8";

export default node;
